import Dialog from "../../../../../components/dialogs/Dialog";
import DialogTitle from "../../../../../components/dialogs/DialogTitle";
import {_transl} from "../../../../../store/localization/TranslMessasge";
import {UsersTranslationKey} from "../UsersTranslationKey";
import DialogContent from "../../../../../components/dialogs/DialogContent";
import React, {useEffect, useState} from "react";
import Grid from "../../../../../components/dialogs/Grid";
import TextField from "../../../../../components/fields/textfield/TextField";
import DialogActions from "../../../../../components/dialogs/DialogActions";
import {SaveButton} from "../../../../../components/button/SaveButton";
import {CancelButton} from "../../../../../components/button/CancelButton";
import {CollectionPermissionLevelDto} from "../../../../../common/apis/user/CollectionPermissionLevelDto";
import userService from "../../../../../common/apis/user/UserApiClient";
import Snackbar from "../../snackbar/Snackbar";
import SingleSelectField from "../../../../../components/fields/select/SingleSelectField";

interface UserPermissionUpdateDialogProps {
    onClose: () => void,
    login: string,
    reloadUserPermissionsGrid: () => void,
    collectionName: string,
    collectionCode: string,
    initialPermission: CollectionPermissionLevelDto,
}

export default function UserPermissionUpdateDialog(props: UserPermissionUpdateDialogProps) {
    const {onClose, login, collectionCode, collectionName, initialPermission, reloadUserPermissionsGrid} = props;

    const [permissionLevels, setPermissionLevels] = useState<CollectionPermissionLevelDto[]>([]);
    const [permissionLevel, setPermissionLevel] = useState<CollectionPermissionLevelDto | null>(initialPermission);

    useEffect(() => {
        const fetchPermissions = async () => {
            const permissions = await getPermissions();
            setPermissionLevels(permissions);
        }
        fetchPermissions();
    }, []);

    useEffect(() => {
        setPermissionLevel(initialPermission);
    }, [initialPermission]);

    useEffect(() => {
        const level = permissionLevels.find((permissionLevel) => permissionLevel.code === initialPermission.code)
        setPermissionLevel(level ?? initialPermission);
    }, [initialPermission, permissionLevels]);

    const getPermissions = async (): Promise<CollectionPermissionLevelDto[]> => {
        try {
            const permissions = await userService.getAllPermissionLevels();
            return permissions;
        } catch (error) {
            return [];
        }
    }

    function onDialogSave() {
        (async () => {
            try {
                await userService.createUserCollectionPermission(login, collectionCode, permissionLevel!.code);
                onClose();
                reloadUserPermissionsGrid();
                Snackbar.success(_transl(UsersTranslationKey.UPDATE_PERMISSION_SUCCEEDED));
            } catch (e) {
                Snackbar.error(_transl(UsersTranslationKey.UPDATE_PERMISSION_SUCCEEDED));
            }
        })();
    }

    return (
        <Dialog open onClose={onClose}>
            <DialogTitle id="scroll-dialog-title"
                         title={_transl(UsersTranslationKey.ADD_PERMISSION_CHANGE)}
                         onDialogClosed={onClose}/>

            <DialogContent>
                <Grid container>
                    <Grid item xs={12}>
                        <TextField id="collection-field"
                                   label={_transl(UsersTranslationKey.ADD_PERMISSION_COLLECTION)}
                                   value={collectionName}
                                   disabled/>
                    </Grid>
                    <Grid item xs={12}>
                        <SingleSelectField
                            id="userPermission-field"
                            label={_transl(UsersTranslationKey.ADD_PERMISSION_PERMISSION_LEVEL)}
                            value={permissionLevel}
                            onChange={(permission) => setPermissionLevel(permission)}
                            options={permissionLevels}
                            getOptionLabel={(permission: CollectionPermissionLevelDto) => _transl(permission.translationKey)}
                            required={true}/>
                    </Grid>
                </Grid>


            </DialogContent>

            <DialogActions>
                <SaveButton onClick={onDialogSave}/>
                <CancelButton onClick={onClose}/>
            </DialogActions>

        </Dialog>
    );
}
